var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _NotAvail_instances, _NotAvail_element, _NotAvail_modal, _NotAvail_init;
import Emitter from '@resources/js/helpers/Emitter';
import Modal from '@resources/js/ui/Modal';
import { isDesktop } from '@resources/js/helpers/media';
const SELECTORS = {
    notice: '.js-not-avail',
    content: '.js-not-avail-content',
    close: '.js-not-avail-close',
};
export const NOT_AVAIL_EVENTS = {
    CLOSE: 'close',
};
class NotAvail extends Emitter {
    constructor() {
        super();
        _NotAvail_instances.add(this);
        _NotAvail_element.set(this, void 0);
        _NotAvail_modal.set(this, void 0);
        __classPrivateFieldSet(this, _NotAvail_element, document.querySelector(SELECTORS.notice), "f");
        if (!__classPrivateFieldGet(this, _NotAvail_element, "f"))
            throw new Error('NotAvail: element not found');
        // починаючи з таблета нотіс не закривається по бекдропу
        __classPrivateFieldSet(this, _NotAvail_modal, new Modal(__classPrivateFieldGet(this, _NotAvail_element, "f"), {
            hideOnBackdrop: isDesktop(),
            lockScroll: false,
            selectors: {
                close: SELECTORS.close,
                content: SELECTORS.content,
            },
        }), "f");
        __classPrivateFieldGet(this, _NotAvail_instances, "m", _NotAvail_init).call(this);
    }
    show() {
        __classPrivateFieldGet(this, _NotAvail_modal, "f").show();
    }
    hide() {
        __classPrivateFieldGet(this, _NotAvail_modal, "f").hide();
    }
}
_NotAvail_element = new WeakMap(), _NotAvail_modal = new WeakMap(), _NotAvail_instances = new WeakSet(), _NotAvail_init = function _NotAvail_init() {
    // CLOSE емітимо лише коли закрив користувач (Modal передає innerTrigger),
    // а не на програмний hide()
    __classPrivateFieldGet(this, _NotAvail_modal, "f").on('hide', ({ innerTrigger } = {}) => {
        if (innerTrigger)
            this.emit(NOT_AVAIL_EVENTS.CLOSE);
    });
};
export default NotAvail;
